// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GDj3","left":"styles_left__2hGq1","right":"styles_right__1IyU2","alert":"styles_alert__2rdcG"};